import PlayersView from "@/systems/modules/players/PlayersView.vue";
import PagePlayerDetails from "@/systems/modules/players/PagePlayerDetails.vue";
import PlayerRelatedPlayersView from "@/systems/modules/players/PlayerRelatedPlayersView.vue";
import PlayerHeaderView from "@/systems/modules/players/PlayerHeaderView.vue";
import authorization from "@/authorization";
import PlayersHeaderView from "@/systems/modules/players/PlayersHeaderView.vue";
import PlayerIdentifiersView from "@/systems/modules/players/identifiers/PlayerIdentifiersView.vue";
import settings from "@/systems/modules/settings/settings";
import {modules} from "@/systems/modules/modules";
import allowlist from "@/systems/modules/allowlist/allowlist";
import punishments from "@/systems/modules/punishments/punishments";
import support from "@/systems/modules/support/support";
import applications from "@/systems/modules/applications/applications";
import analytics from "@/systems/modules/analytics/analytics";

export default {
    initialize: () => {

    },
    homeWidgets: [],
    registerHomeWidget(authorize, component) {
        this.homeWidgets.push({
            authorize: authorize,
            component: component
        });
    },
    getRoutes: () => [
        {
            name: "community.players",
            path: "players",
            component: PlayersHeaderView,
            meta: {
                authorize: () => authorization.permission("community.players.view"),
            },
            redirect: { name: "community.players.list" },
            children: [
                {
                    name: "community.players.online",
                    path: "online",
                    component: PlayersView,
                    props: route => ({ online: true, communityId: route.params.communityId }),
                    meta: {
                        authorize: () => authorization.permission("community.players.online.view")
                    }
                },
                {
                    name: "community.players.list",
                    path: "list",
                    component: PlayersView,
                    props: true
                },
                {
                    name: "community.players.identifiers",
                    path: "identifiers",
                    component: PlayerIdentifiersView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("community.players.identifiers.view")
                    }
                },
                ...settings.getRoutes(modules.players)
            ]
        },
        {
            name: "community.player",
            path: "players/:playerId",
            component: PlayerHeaderView,
            props: true,
            meta: {
                authorize: () => authorization.permission("community.players.view"),
            },
            redirect: {name: "community.player.general"},
            children: [
                {
                    name: "community.player.general",
                    path: "basic",
                    component: PagePlayerDetails,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("community.players.view")
                    }
                },
                {
                    name: "community.player.relatedPlayers",
                    path: "related-players",
                    component: PlayerRelatedPlayersView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("community.players.related.view"),
                    }
                },
                ...allowlist.getPlayerRoutes(),
                ...punishments.getPlayerRoutes(),
                ...support.getPlayerRoutes(),
                ...applications.getPlayerRoutes(),
                ...analytics.getPlayerRoutes(),
            ]
        },
    ]
};